/**
 * Per-device tracking of a pending "authorize this device" request.
 *
 * The account-wide `user_profiles.device_authorization_pending` flag used to gate
 * every signed-in session of a user, which meant logging in on a phone bounced the
 * laptop to the authorization screen. Pending state now lives on the device that
 * actually triggered it: the authorization id returned by `check-device` is stored
 * in this browser's localStorage and cleared once authorized/expired.
 */

const KEY_PREFIX = "acex:device-auth-pending:";

function key(userId: string) {
  return `${KEY_PREFIX}${userId}`;
}

export function setPendingDeviceAuth(userId: string, authorizationId: string) {
  try {
    localStorage.setItem(key(userId), authorizationId);
  } catch {
    /* ignore */
  }
}

export function getPendingDeviceAuth(userId?: string | null): string | null {
  if (!userId) return null;
  try {
    return localStorage.getItem(key(userId));
  } catch {
    return null;
  }
}

export function clearPendingDeviceAuth(userId?: string | null) {
  if (!userId) return;
  try {
    localStorage.removeItem(key(userId));
  } catch {
    /* ignore */
  }
}
